import React, { useState, useEffect, useRef } from "react";
import BankAccountService from "../../../../../ops/modules/patients/modules/new-bridge/services/BankAccountService";
import EventService from "../../../../../../service/event/EventService";

const SecurePDFViewer = ({ bankAccountResponse }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const bankAccountService = new BankAccountService();

  const BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED = 1;
  const BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED = 0;
  const BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED = 2;

  const fetchPDF = async () => {
    bankAccountService.fetchChequeFile(
      bankAccountResponse?.id,
      async (response) => {
        if (!response.ok) {
          EventService.emit("showError", {
            message: "Failed to fetch the cancelled cheque",
          });
        }

        try {
          const blob = await response.blob();

          // Force the MIME type to be PDF so the browser handles it correctly
          const pdfBlob = new Blob([blob], { type: "application/pdf" });
          const url = URL.createObjectURL(pdfBlob);
          setBlobUrl(url);

          // CLEANUP: Revoke the URL when the component unmounts
          // This tells the browser to wipe the file from memory
          // return () => URL.revokeObjectURL(objectURL);
        } catch (err) {
          EventService.emit("showError", {
            message: "Error loading the cancelled cheque",
          });
        }
      },
      (err) => {
        EventService.emit("showError", {
          message: "Error loading the cancelled cheque : " + err.toString(),
        });
      }
    );
  };

  useEffect(() => {
    if (
      bankAccountResponse?.id &&
      Boolean(
        bankAccountResponse?.verificationStatus ===
          BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED
      )
    ) {
      fetchPDF();
    }
  }, [bankAccountResponse]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Block Ctrl+S and Ctrl+P
      if ((e.ctrlKey || e.metaKey) && (e.key === "s" || e.key === "p")) {
        e.preventDefault();
        alert("Saving/Printing is disabled for security.");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div style={{ width: "100%" }} onContextMenu={(e) => e.preventDefault()}>
      {blobUrl ? (
        <iframe
          src={`${blobUrl}#toolbar=0&navpanes=0&scrollbar=0`}
          title="Cheque Viewer"
          width="100%"
          height="600px"
          style={{
            border: "none",
          }}
          // Sandbox attribute prevents the PDF from running scripts
          // sandbox="allow-same-origin"
        />
      ) : (
        <p>Loading document...</p>
      )}
    </div>
  );
};

export default SecurePDFViewer;
